<template>
  <router-view v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <Component :is="Component" />
    </transition>
  </router-view>
  <Loader :show="loader.status" :key="loader.key" />
  <template v-if="loggedIn">
    <OnBoard  v-if=" $q.screen.width > 992 "/>
  </template>
  <!-- <ScrollToTopButton /> -->
</template>

<script setup>
import Loader from '@/components/ui/LoaderComponent.vue';
import OnBoard from '@/components/ui/OnBoard.vue';
// import ScrollToTopButton from '@/components/ui/ScrollToTopButton.vue';
import { useLoaderStore } from '@/stores/loader';
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useMeta , useQuasar } from 'quasar';
import { useMetaStore } from './stores/meta';
import { onMounted, onUnmounted } from 'vue';
import { useAuthStore } from '@/stores/auth';
 import { getDataFresh } from '@/services/fresh-stored-data';

const loader = useLoaderStore();
const route = useRoute();
const $q= useQuasar();
const authStore = useAuthStore();
const metaStore = useMetaStore();
const metaTags = ref(route.meta)
const computedMetaTags = computed(() => metaStore.metaTags)


const loggedIn = computed(() => authStore.isLoggedIn);


useMeta(computedMetaTags.value);


watch(
  () => route.path,
  async () => {
    metaTags.value = { ...route.meta };
  },
  { immediate: true, deep: true }
)
// check if website cached reload
// const checkLogoClick = () => {
//     if (!document.hidden) {
//       const logo = document.querySelector('#logo-global');
//       if (logo) {
//         try {
//           const testEvent = new Event('click', { bubbles: true, cancelable: true });
//           const clickWorked = logo.dispatchEvent(testEvent);
//           if (!clickWorked) {
//             window.location.reload();
//           }
//         } catch (e) {
//           window.location.reload();
//         }
//       }
//     }
//   }

onMounted(() => {
  window.addEventListener('message', authStore.handleAuthMessage);
  if(loggedIn.value) {
    getDataFresh();
  }
  // document.addEventListener('visibilitychange', checkLogoClick);
});

onUnmounted(() => {
  window.removeEventListener('message', authStore.handleAuthMessage);
  // document.removeEventListener('visibilitychange', checkLogoClick);

});
</script>
